import React from 'react';
import { Button, Flex, Skeleton, Text, Spinner } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '../../contexts/LanguageContext';
import { useLanguageChanger } from '../../hooks/useLanguageChanger';

const AleaLanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const { availableLanguages, loading, error } = useLanguageContext();
  const { changeLanguage, loadingLanguage } = useLanguageChanger();

  if (loading) {
    return (
      <Flex justifyContent="center" mt="10px" gap="10px">
        <Skeleton height="32px" width="50px" borderRadius="md" />
        <Skeleton height="32px" width="50px" borderRadius="md" />
        <Skeleton height="32px" width="50px" borderRadius="md" />
      </Flex>
    );
  }

  if (error) {
    return (
      <Flex justifyContent="center" mt="10px">
        <Text fontSize="sm" color="red.500">
          Language loading failed
        </Text>
      </Flex>
    );
  }

  if (availableLanguages.length === 0) {
    return null;
  }

  return (
    <Flex 
      justifyContent="center" 
      mt="10px" 
      gap="10px"
      flexWrap="wrap"
    >
      {availableLanguages.map((language) => (
        <Button
          key={language.code}
          onClick={() => changeLanguage(language.code)}
          size="sm"
          variant={i18n.language === language.code ? 'solid' : 'outline'}
          title={language.name}
          isLoading={loadingLanguage === language.code}
          isDisabled={loadingLanguage !== null}
        >
          {loadingLanguage === language.code ? (
            <Spinner size="sm" />
          ) : (
            <Flex align="center" gap="5px">
              <Text fontSize="12px">{language.flag}</Text>
              <Text fontSize="12px" fontWeight="500">
                {language.code.toUpperCase()}
              </Text>
            </Flex>
          )}
        </Button>
      ))}
    </Flex>
  );
};

export default AleaLanguageSwitcher;
